<template>
    <div class="dataAny2" v-if="isshow">
        <div class="topSearch">
            <el-date-picker v-model="date" type="daterange" align="right" unlink-panels
            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :picker-options="pickerOptions0">
            </el-date-picker>
            <el-input v-model="param.customername" placeholder="请输入用户名" clearable></el-input>
            <el-button type="primary" plain @click="handleQuery">搜索</el-button>
            <el-button @click="handleExport">导出</el-button>
        </div>
        <div class="result-list btn-operate-list">
            <el-table :data="tableData" style="width: 100%">
                <el-table-column prop="name" label="用户" class-name="title">
                    <template slot-scope="scope">
                        <div class="headImg">
                            <img :src="scope.row.customericonurl" alt="">
                            <span>{{scope.row.customername}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="orderno" label="订单号" class-name="center" width="200"></el-table-column>
                <el-table-column prop="datetime" label="订单时间" class-name="center" width="160"></el-table-column>
                <el-table-column prop="status" label="订单状态" class-name="center">
                    <template slot-scope="scope">
                       <span :class="{'yellowcolor':scope.row.status==9,'bluecolor':scope.row.status==30,'redcolor':scope.row.status==100}">{{scope.row.statustext}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="ordermoney" label="订单金额" class-name="center"></el-table-column>
                <el-table-column prop="finalpaymoney" label="实付金额" class-name="center"></el-table-column>
                <el-table-column prop="paytypename" label="支付方式" class-name="center"></el-table-column>
                <el-table-column label="操作"  width="100"  label-class-name="tr">
                    <template slot-scope="scope">
                        <div class="tr">
                            <el-button @click="handleDet(scope.row)" type="text" size="small">订单详情</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <page :total="total" @getList="_getList" ref="page"></page>
        </div>
    </div>
</template>

<script>
    import {getCourseInfoOrderList, getExportCoursestudyinfoByOrder} from 'api/curriculumApi'
    import Page from 'base/page/page'
    import {dateFormat} from 'common/js/tools'
    import {mapGetters, mapActions} from 'vuex'
    export default {
        name: "dataAny2",
        data(){
            return{
                param:{
                    customername:'',
                    courseid:this.$route.query.innerid?this.$route.query.innerid:'',
                    begintime:'',
                    endtime:'',
                },
                isshow:false, // 是否显示页面
                date:[],
                tableData:[],
                total: 0,
                pickerOptions0: {
                    disabledDate(time) {
                        let curDate = (new Date()).getTime();
                        let three = 60 * 24 * 3600 * 1000;
                        let threeMonths = curDate - three;
                        return time.getTime() > Date.now() || time.getTime() < threeMonths;
                    }
                },
            }
        },
        mounted(){
           this._getList()
        },
        methods:{
            // 获取列表
            _getList(){
                this.setLoading(true)
                if(this.date){
                    this.param.beginTime = this.date[0]
                    this.param.endTime = this.date[1]
                }else{
                    this.param.beginTime = ''
                    this.param.endTime = ''
                }
                getCourseInfoOrderList({
                    data: Object.assign({}, this.param, this.page),
                    success: data => {
                        this.setLoading(false)
                        this.isshow=true
                        this.tableData = data.data.content
                        this.total = data.data.pageinfo.rowCount
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            handleQuery(){
                this.$refs.page.handleSizeChange(1)
            },
            // 跳转至订单详情
            handleDet(row){
                this.$router.push({name: 'OrderInfo', query: {orderinnerid: row.orderinnerid}})
            },
            // 导出
            handleExport(){
                this.setLoading(true)
                getExportCoursestudyinfoByOrder({
                    data: {courseid: this.courseid},
                    success: data => {
                        let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                        let fileName = '订单列表' + dateFormat(new Date()) + '.xls'
                        if (window.navigator.msSaveOrOpenBlob) {
                            navigator.msSaveBlob(blob, fileName)
                        } else {
                            var link = document.createElement('a')
                            link.href = window.URL.createObjectURL(blob)
                            link.download = fileName
                            link.click() // 释放内存
                            window.URL.revokeObjectURL(link.href)
                        }
                        this.setLoading(false)
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            ...mapActions([
                'setLoading',
            ])
        },
        computed: {
            ...mapGetters([
                'page'
            ])
        },
        components:{
            Page
        }
    }
</script>

<style scoped lang="scss">
    .dataAny2{
        .topSearch{
            display: flex;
            margin-bottom: 20px;
            justify-content: flex-end;
            .el-input{
                width: 220px;
                margin: 0 10px;
            }
            .el-range-editor.el-input__inner{
                padding: 0 10px;
                width: 240px;
            }
        }
        .result-list{
            .yellowcolor{
                color: #E6A23C;
            }
            .bluecolor{
                color: #409EFF;
            }
            .redcolor{
                color: #EC5E69;
            }
        }
    }
</style>
